import React from 'react';
import Button from '../../../components/ui/Button';

const QuickActions = ({ onAction }) => {
  const actions = [
    {
      id: 'upload',
      label: 'Upload Dataset',
      icon: 'Upload',
      variant: 'default',
      description: 'Share your research data'
    },
    {
      id: 'request',
      label: 'Request Access',
      icon: 'Lock',
      variant: 'outline',
      description: 'Request restricted data'
    },
    {
      id: 'api',
      label: 'API Documentation',
      icon: 'Code',
      variant: 'outline',
      description: 'Integrate with our API'
    },
    {
      id: 'collaborate',
      label: 'Start Collaboration',
      icon: 'Users',
      variant: 'outline',
      description: 'Connect with researchers'
    }
  ];

  return (
    <div className="bg-[var(--color-card)] rounded-lg p-6 border border-[var(--color-border)]">
      <h3 className="text-lg font-semibold text-[var(--color-card-foreground)] mb-6">
        Quick Actions
      </h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {actions?.map((action) => (
          <button
            key={action?.id}
            onClick={() => onAction(action?.id)}
            className="flex flex-col items-start gap-2 p-4 rounded-lg border border-[var(--color-border)] hover:bg-[var(--color-muted)] animation-organic text-left"
          >
            <div className="flex items-center gap-3 w-full">
              <div className="w-10 h-10 rounded-lg bg-[var(--color-primary)]/10 flex items-center justify-center flex-shrink-0">
                <Button
                  variant="ghost"
                  size="icon"
                  iconName={action?.icon}
                  className="pointer-events-none"
                />
              </div>
              <div className="flex-1 min-w-0">
                <h4 className="text-sm font-medium text-[var(--color-card-foreground)] mb-1">
                  {action?.label}
                </h4>
                <p className="text-xs text-[var(--color-muted-foreground)]">
                  {action?.description}
                </p>
              </div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default QuickActions;